import User from '../../../models/User'

export enum UserSolutionControlValue {
  None,
  Read,
  Write,
}

export type UserSolutionFormRow = {
  user: User
  universalInventoryRead: UserSolutionControlValue
  rateManagement: UserSolutionControlValue
  blackouts: UserSolutionControlValue
  reporting: UserSolutionControlValue
}


export type LocationHoursMode = 'open' | 'closed' | 'open24hours'

export interface LocationHoursModalResult {
  weekdays: any[] // TODO
  mode: LocationHoursMode
  openLocal: null | string
  closeLocal: null | string
}
